module.exports = __webpack_public_path__ + "img/Trinidad-and-Tobago.2eba3c1f.png";